import styled from 'styled-components';

export const MessageReactionsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.2rem;
  margin-top: 1.5em;

  > .message-reaction {
    display: flex;
    align-items: center;
  }

  svg {
    color: ${({ theme }) => theme.color.reaction};
  }

  .active {
    &:hover {
      svg {
        color: ${({ theme }) => theme.color.reactionActive};
      }
    }

    svg {
      color: ${({ theme }) => theme.color.reactionActive};
    }
  }
`;
